import { useTranslation } from "react-i18next";
import { Drawer } from "melco-ui";
import MachineLicenseAssignment from "./MachineLicenseAssignment";
import { useMachineLicenseGetAssignment } from "../../../hooks/infrastructure/machinelicenses/useMachineLicenseGetAssignment";

type ManageMachineLicenseDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  callbackFn: () => void
};

export const ManageMachineLicenseDrawer: React.FC<ManageMachineLicenseDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  callbackFn }) => {
  const { t } = useTranslation();
  let { data: assignmentData } = useMachineLicenseGetAssignment()

  return (
    <Drawer
      title={t("machineLicenses.licenseAssignment.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{
        //maxHeight: 'calc(100vh - 64px)', // Adjust based on your header/footer
        overflowY: 'auto',
        paddingBottom: 80, // Add padding equal to or greater than Footer height
      }}
    // bodyStyle={{ padding: 0 }}
    >
      <>
        {assignmentData && <MachineLicenseAssignment

          callbackFn={callbackFn}
          assignmentData={assignmentData}
        />
        }
      </>
    </Drawer>
  );
};
